import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import TopBar from '../components/TopBar';
import '../App.css';

const About = () => {
  return (
    <Box sx={{ 
      minHeight: '100vh',
      backgroundColor: '#0B1016',
      backgroundImage: `
        radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.03) 0%, transparent 50%),
        radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.02) 0%, transparent 50%),
        linear-gradient(180deg, #0B1016 0%, #0a0e13 100%)
      `,
      position: 'relative',
      overflow: 'hidden'
    }}>
      <TopBar />
      <Container component="main" maxWidth="md" sx={{ pt: 10, pb: 6, px: { xs: 3, sm: 4 } }}>
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          <Typography 
            component="h1" 
            variant="h3" 
            sx={{ 
              mb: 4,
              fontWeight: 700,
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
              color: '#ffffff',
              textShadow: '0 2px 20px rgba(255, 255, 255, 0.1)',
              letterSpacing: '-0.02em',
              lineHeight: 1.2
            }}
          >
            About Clearance Scouts
          </Typography>
          
          <Box sx={{ 
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: -20,
              left: -20,
              right: -20,
              bottom: -20,
              background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, transparent 50%)',
              borderRadius: '8px',
              zIndex: -1
            }
          }}>
            <Typography 
              variant="body1" 
              sx={{ 
                mb: 4, 
                fontSize: { xs: '1rem', sm: '1.125rem' }, 
                lineHeight: 1.9,
                color: '#ffffff',
                fontWeight: 300
              }}
            >
              Clearance Scouts is a community-driven platform that helps you discover and share the best clearance deals, 
              liquidation sales, and heavy discount retail events happening in your area.
            </Typography>

            <Typography 
              variant="body1" 
              sx={{ 
                mb: 4, 
                lineHeight: 1.9,
                color: '#ffffff',
                fontSize: { xs: '1rem', sm: '1.125rem' },
                fontWeight: 300
              }}
            >
              Our mission is to provide a new and dynamic way to share clearance deals in a locale-based way with other users.
              As we grow, reputation and incentives can be increased to help hunt out deals which are actually becoming{' '}
              <Box component="span" sx={{ color: '#000000', backgroundColor: '#ffffff', px: 0.5, fontWeight: 700, display: 'inline-block' }}>
                EASIER to find than EVER
              </Box>
              , if you go out and look - and share.
            </Typography>

            <Box 
              component="ul" 
              sx={{ 
                pl: 0,
                mb: 4,
                listStyle: 'none',
                '& li': {
                  mb: 2,
                  position: 'relative',
                  pl: 3,
                  '&::before': {
                    content: '"•"',
                    position: 'absolute',
                    left: 0,
                    color: '#ffffff',
                    fontSize: '1.5rem',
                    lineHeight: 1.2
                  }
                }
              }}
            >
              <li>
                <Typography 
                  variant="body1" 
                  sx={{ 
                    color: '#ffffff',
                    fontSize: { xs: '1rem', sm: '1.125rem' },
                    lineHeight: 1.9,
                    fontWeight: 300
                  }}
                >
                  Browse clearance events on an interactive map
                </Typography>
              </li>
              <li>
                <Typography 
                  variant="body1" 
                  sx={{ 
                    color: '#ffffff',
                    fontSize: { xs: '1rem', sm: '1.125rem' },
                    lineHeight: 1.9,
                    fontWeight: 300
                  }}
                >
                  Share deals you discover at local stores
                </Typography>
              </li>
              <li>
                <Typography 
                  variant="body1" 
                  sx={{ 
                    color: '#ffffff',
                    fontSize: { xs: '1rem', sm: '1.125rem' },
                    lineHeight: 1.9,
                    fontWeight: 300
                  }}
                >
                  Get notified about new deals in your area
                </Typography>
              </li>
              <li>
                <Typography 
                  variant="body1" 
                  sx={{ 
                    color: '#ffffff',
                    fontSize: { xs: '1rem', sm: '1.125rem' },
                    lineHeight: 1.9,
                    fontWeight: 300
                  }}
                >
                  Help the community by marking helpful deals, updating events, etc
                </Typography>
              </li>
            </Box>

            <Typography 
              variant="body1" 
              sx={{ 
                mb: 4, 
                lineHeight: 1.9,
                color: '#ffffff',
                fontSize: { xs: '1rem', sm: '1.125rem' },
                fontWeight: 300
              }}
            >
              Clearance Scouts is dedicated to growing a grassroots community of users who both contribute to and benefit from the platform.
            </Typography>

            <Typography 
              variant="body1" 
              sx={{ 
                mb: 6, 
                lineHeight: 1.9,
                color: '#ffffff',
                fontSize: { xs: '1rem', sm: '1.125rem' },
                fontWeight: 300
              }}
            >
              Have questions, suggestions, or feedback? We'd love to hear from you!{' '}
              <Box 
                component="span" 
                sx={{ 
                  color: '#000000', 
                  backgroundColor: '#ffffff', 
                  px: 0.5, 
                  fontWeight: 600,
                  display: 'inline-block'
                }}
              >
                support@clearancescouts.com
              </Box>
            </Typography>
          </Box>
          
          <Box 
            sx={{ 
              mt: 6, 
              pt: 4, 
              textAlign: 'center',
              position: 'relative',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '100px',
                height: '1px',
                background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent)'
              }
            }}
          >
            <Typography 
              variant="caption" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.5)', 
                fontSize: '0.75rem',
                fontWeight: 300,
                letterSpacing: '0.05em'
              }}
            >
              © 2025 Mark Forsythe. All Rights Reserved.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default About;
